import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TrackingService} from '@services/tracking.service';
import {environment} from '~/environments/environment';
import {HttpClient} from '@angular/common/http';
import {UserService} from '@services/user.service';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {AuthenticationService} from '@services/authentification.service';

@Component({
    selector: 'app-retry',
    templateUrl: './retry.component.html',
    styleUrls: ['./retry.component.scss']
})
export class RetryComponent implements OnInit {

    user: User = Object.assign({}, EMPTY_USER);
    step = 1;
    loading = true;
    status = null;
    reason = null;
    amount = 0;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private http: HttpClient,
        public dialogRef: MatDialogRef<RetryComponent>,
        public userService: UserService,
        public authenticationService: AuthenticationService,
        public trackingService: TrackingService) {

    }

    ngOnInit(): void {
        this.step = this.data.step;
        if (this.step == 2) {
            this.retryPaiment();
        }
        this.user = this.authenticationService.currentUser;
        this.userService.getInvoice().subscribe(
            invoices => {
                if (invoices.length > 0) {
                    this.amount = invoices[0].amount / 100;
                }
            },
            (error) => {
                console.log(error);
            });
    }

    reInit() {
        this.step = 1;
        this.loading = false;
    }

    retryPaiment() {
        this.step = 2;
        this.loading = true;
        this.http.post<any>(`${environment.apiUrl}app/paiement/retry`, {}).subscribe(
            result => {
                this.loading = false;
                this.status = result.success;
                this.reason = result.reason;
            },
            (error) => {
                console.log(error);
                this.loading = false;
            });
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        this.dialogRef.close(true);
    }
}
